import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getUser } from './getUser';
export const getScopes = createSelector(getUser, user => Array.from(new Set(get('scopes', user))));